import {
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {DetailPage} from './pages/DetailPage.tsx';
import {rbacActions} from "../../config/rbac/actions.ts";
import {RestrictedRouteElement} from "../../components/RestrictedRouteElement.tsx";


export const MeteringRecordsLayout = () => {

    return (
        <Routes>
            <Route
                path='/'
                element={<RestrictedRouteElement rbacAction={rbacActions.ListMeteringRecords}>
                    <IndexPage/></RestrictedRouteElement>}
            />
            {/* MeteringRecord has a two-part key — the detail route carries both
                segments (customerId / sortKey), each encodeURIComponent'd by the
                table's navigate and auto-decoded by useParams. */}
            <Route
                path=':customerId/:sortKey'
                element={<RestrictedRouteElement rbacAction={rbacActions.GetMeteringRecord}>
                    <DetailPage/></RestrictedRouteElement>}
            />
        </Routes>
    );
};
